//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Bishop',
  data() {
    return {
      form:{
        dil:'',
        fade_away:'',
        fet:'',
        stiffness:'',
        position:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'未扩张'},
        {value:"1",name:'扩张1~2cm'},
        {value:"2",name:'扩张3~4cm'},
        {value:"3",name:'扩张≥5cm'},
      ],
      dataList2:[
        {value:"0",name:'0%~30%'},
        {value:"1",name:'40%~50%'},
        {value:"2",name:'60%~70%'},
        {value:"3",name:'≥80%'},
      ],
      dataList3:[
        {value:"0",name:'-3（坐骨棘上3cm）'},
        {value:"1",name:'-2（坐骨棘上2cm）'},
        {value:"2",name:'-1~0（靠近或到达坐骨棘水平）'},
        {value:"3",name:'+1~+2（坐骨棘下一到两厘米）'},
      ],
      dataList4:[
        {value:"0",name:'硬'},
        {value:"1",name:'适中'},
        {value:"2",name:'软'}
      ],
      dataList5:[
        {value:"0",name:'朝后'},
        {value:"1",name:'居中'},
        {value:"2",name:'朝前'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.dil + form.fade_away + form.fet + form.stiffness + form.position
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/Bishop.vue